<template>
    <div class="pending-information-form">
        <h1 class="pending-information-form__title">
            {{ $t('Complete your information') }}
        </h1>
        <p class="pending-information-form__info-text mb-1">
            {{ $t('We detected that you still need to complete some information required for the proper functioning of your account, in order to register this information you can click on the following button') }}
        </p>
        <ui-button
            class="pending-information-form__button w-100 mb-0"
            variant="accent"
            @click="$refs.pendingAccountInformationModal.show()"
        >
            {{ $t('Update information') }}
        </ui-button>
        <pending-account-information-modal
            ref="pendingAccountInformationModal"
            :user="user"
            @accountInformationUpdated="onAccountInformationUpdated"
        />
    </div>
</template>

<script>
import UiButton from '@/components/ui/buttons/Button.vue';
import PendingAccountInformationModal from '@/components/accounts/PendingAccountInformationModal.vue';

export default {
    name: 'PendingInformationForm',
    components: {
        UiButton,
        PendingAccountInformationModal,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    emits: ['userUpdated'],
    methods: {
        onAccountInformationUpdated(userData) {
            this.$emit('userUpdated', userData);
        },
    },
};
</script>

<style lang="scss">
.pending-information-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>